import { Fragment } from "react";
import { Button, Checkbox, Table, Divider, Tag } from 'antd';
import SelectGroup from './SelectGroup';
import DragDropTable from './DragDropTable';
import Text from 'antd/es/typography/Text';
import Input from "antd/es/input/Input";

export default function OptionsTable(props) {
  const {
    options,
    numSelects,
    onRemoveOption,
    onChangeGroup,
    onChangeIsAnswer,
    onChangeAnswer,
    // setOptions, // for dnd table
  } = props;

  const shouldUpdate = (option, answer) => {
    if (option.answer !== answer) onChangeAnswer(option, answer);
  }

  const columns = [
    {
      title: 'Answer',
      dataIndex: 'answer',
      key: 'answer',
      render: (answer, option) => {
        return (
          <Fragment>
            <Button onClick={()=>onRemoveOption(option)}
                    shape="circle" size="small" icon="minus"
            />
            <Text editable={{ onChange: (newAnswer)=>shouldUpdate(option, newAnswer) }}>
              {answer}
            </Text>
          </Fragment>
        )
      }
    },
    {
      title: 'Select',
      dataIndex: 'select',
      key: 'select',
      render: (select, option) => {
        return <SelectGroup value={select} numSelects={numSelects}
                            onChange={(select)=>onChangeGroup(option, select)}
        />
      }
    },
    {
      title: 'Correct',
      dataIndex: 'is_answer',
      key: 'is_answer',
      render: (is_answer, option) => {
        return (
          <Checkbox checked={is_answer}
                    onChange={()=>onChangeIsAnswer(option, !is_answer)} />
        )
      }
    },
  ];

  const data = options.map((option, index) => {
    return {
      key: index,
      answer: option.value,
      select: option.select,
      is_answer: option.is_answer,
    }
  });

  /*
    was using this for dnd table
  */
  // const onChange = (data) => {
  //   const options = data.map((item, index) => {
  //     return {
  //       value: item.answer,
  //       select: item.select,
  //       is_answer: item.is_answer,
  //     }
  //   });
  //   setOptions(options);
  // }

  return (
    <Table columns={columns} dataSource={data} />
  )
}
